/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import { FaAngleLeft, FaAngleRight, FaTimes, FaStar } from 'react-icons/fa';
import Switch from 'react-switch';
import CurrencyInput from 'react-currency-input';
import Select from 'react-select';

import api from 'api';

import { Context } from 'context/AuthContext';

import BuscaProdutos from './BuscaProdutos';
import ProdutosEspecificos from './ProdutosEspecificos';

import {
  GET_SOLICITACAO_PRODUTO,
  GET_LAYOUT_PRODUTOS_ESPECIFICOS,
  GET_LAYOUT_PRODUTOS_OBRIGATORIOS,
} from 'services/Solicitacao';
import { VALIDA_PREMISSA_INOVACAO } from 'services/Premissa';

import { passos, getCampoObrigatorioClassName } from '../../../_constants';

const Produtos = (props) => {
  const { showLoader } = useContext(Context);
  const requerProdutoInovacao = props.requerProdutoInovacao;
  const [itensObrigatoriosAdicionados, setItensObrigatoriosAdicionados] = useState(0);

  let loja = props.loja;
  let entities = props.entities;
  let clienteLayouts = props.clienteLayouts;
  let solicitacao = props.solicitacao;
  solicitacao.solicitacaoDados = solicitacao.solicitacaoDados || {};
  let solicitacaoDados = solicitacao.solicitacaoDados;
  let renderErrors = props.renderErrors;
  let errors = (solicitacao.errors || []).filter(
    (error) => error.passo === passos.passoProdutos.nro
  );
  let avancar = props.avancar;
  let hideVoltar = props.hideVoltar;
  let voltar = props.voltar;
  let material = []
    .concat(
      ...entities.tipoMateriais.map(
        (tipoMaterial) => tipoMaterial.materiaisComunicacao
      )
    )
    .find((m) => m.materialComunicacaoId === solicitacao.materialComunicacaoId);
  let layoutArte =
    (entities.clienteLayouts.layoutArtes || []).find(
      (layout) => layout.layoutArteId === solicitacaoDados.layoutArteId
    ) || {};
  let selectListUnidades = entities.unidades.map((unidade) => {
    return {
      value: unidade,
      label: unidade,
    };
  });

  const [layoutProdutosEspecificos, setLayoutProdutosEspecificos] = useState(
    solicitacao.layoutProdutosEspecificos || {}
  );
  const [layoutProdutosObrigatorios, setLayoutProdutosObrigatorios] = useState(
    solicitacao.layoutProdutosObrigatorios || {}
  );

  let minimoProdutos =
    layoutArte.minimoProdutos > 0
      ? layoutArte.minimoProdutos
      : material.minimoProdutos || 0;

  let maximoProdutos =
    layoutArte.maximoProdutos > 0
      ? layoutArte.maximoProdutos
      : material.maximoProdutos || 0;

  //pra funcionar o rascunho no mobile precisou guardar esses campos
  solicitacao.solicitacaoDados.minimoProdutos = minimoProdutos;
  solicitacao.solicitacaoDados.maximoProdutos = maximoProdutos;
  //--

  const [solicitacaoProdutos, setSolicitacaoProdutos] = useState(
    solicitacao.solicitacaoProdutos || []
   );

  const [inovacaoMsgErro, setInovacaoMsgErro] = useState('');

  //=============================================================================================================================
  solicitacao.isValidProdutos = () => {
    if ((solicitacao.solicitacaoProdutos || []).length === 0) return false;

    if (
      minimoProdutos > 0 &&
      solicitacao.solicitacaoProdutos.length < minimoProdutos
    )
      return false;

    if (
      maximoProdutos > 0 &&
      solicitacao.solicitacaoProdutos.length > maximoProdutos
    )
      return false;

    return true;
  };

  const countInovacao = (produtos) => {
    let count = 0;
    produtos.forEach((x) => {
      if (x.inovacao || x.produto.inovacao) {
        count++;
      }
    });

    return count;
  }

  //=============================================================================================================================

  // Atualiza produtos e seus detalhamentos da solicitacao
  useEffect(() => {
    (async () => {
      atualizarProdutosRascunho();
    })();
  }, [solicitacao, clienteLayouts]);


  //carregar os produtos especificos do layout sempre que houver mudança de layout
  useEffect(() => {
    if (
      !layoutArte.possuiProdutosEspecificos ||
      layoutArte.layoutArteId ===
      (solicitacao.layoutProdutosEspecificos || {}).layoutArteId
    )
      return;

    (async () => {
      showLoader(true);
      // const result = await GET_LAYOUT_PRODUTOS_ESPECIFICOS({
      //   layoutArteId: layoutArte.layoutArteId,
      // });
      const result = await GET_LAYOUT_PRODUTOS_ESPECIFICOS(layoutArte.layoutArteId);

      if (result?.value) {
        solicitacao.layoutProdutosEspecificos = result.value;
        setLayoutProdutosEspecificos(solicitacao.layoutProdutosEspecificos);
      }

      showLoader(false);
    })();
  }, [solicitacao, clienteLayouts]);

  //carregar os produtos obrigatorios do layout sempre que houver mudança de layout
  useEffect(() => {
    if (
      !layoutArte.possuiProdutosObrigatorios ||
      layoutArte.layoutArteId ===
      (solicitacao.layoutProdutosObrigatorios || {}).layoutArteId
    )
      return;

    (async () => {
      showLoader(true);

      // const result = await GET_LAYOUT_PRODUTOS_OBRIGATORIOS({
      //   layoutArteId: layoutArte.layoutArteId,
      // });
      const result = await GET_LAYOUT_PRODUTOS_OBRIGATORIOS(layoutArte.layoutArteId);

      if (result?.value) {
        solicitacao.layoutProdutosObrigatorios = result.value;
        setLayoutProdutosObrigatorios(solicitacao.layoutProdutosObrigatorios);

        adicionarProdutosObrigatorios();
      }

      showLoader(false);
    })();
  }, [solicitacao, clienteLayouts]);

  useEffect(() => {
    if (requerProdutoInovacao) {
      (async () => {

        showLoader(true);
        const qtdProduto = solicitacaoProdutos.length;
        const qtdInovacao = countInovacao(solicitacaoProdutos);
        const res = await VALIDA_PREMISSA_INOVACAO(loja.lojaId, qtdProduto, qtdInovacao);
        setInovacaoMsgErro(res?.data?.value?.mensagem);
        showLoader(false);
      })();
    }
    let regionalProdutosIds = [];

    if (entities.regionalProdutosObrigatorios && entities.regionalProdutosObrigatorios.produtos) {
      for (var i = 0; i < entities.regionalProdutosObrigatorios.produtos.length; i++) {
        regionalProdutosIds.push(entities.regionalProdutosObrigatorios.produtos[i].produtoId);
      }
    }

    console.log(regionalProdutosIds);
    var regionalProdutos = solicitacaoProdutos.filter(x => regionalProdutosIds.findIndex(p => p === x.produtoId) >= 0);
    console.log(regionalProdutos);
    setItensObrigatoriosAdicionados(regionalProdutos.length);
  }, [solicitacaoProdutos])


  //=============================================================================================================================

  // Atualiza os produtos do rascunho com os dados atuais do banco de dados
  // - Remove produtos invalidos
  // - Atualiza as informacoes e detalhamentos dos produtos
  const atualizarProdutosRascunho = () => {
    if (!loja || !loja.lojaId) return;

    let produtosRascunho = props.solicitacao?.solicitacaoProdutos || [];
    //adicionarListaProdutos(produtosRascunho);

    (async function () {
      showLoader(true);

      let produtosInvalidos = [];
      let produtosValidos = [];
      for (let i = 0; i < produtosRascunho.length; i++) {
        let produto = produtosRascunho[i];
        const result = await GET_SOLICITACAO_PRODUTO({
          lojaId: loja.lojaId,
          produtoId: produto.produtoId,
        });

        if (!result?.value) {
          produtosInvalidos.push(produto);
          continue;
        }

        //pra funcionar no mobile
        let produtoEncontrado = { ...result.value };
        produtoEncontrado.produto = result.value;
        produtoEncontrado.inovacao = result.inovacao;
        //--

        produtosValidos.push(produtoEncontrado);
      }

      // Remove os produtos invalidos
      produtosInvalidos.forEach((produto)=>{
        let idx = produtosRascunho.indexOf(item => item.produto?.codigo == produto.codigo);
        produtosRascunho.splice(idx, 1);
      })

      // Atualiza os dados do produto
      produtosValidos.forEach((produto)=>{
        let idx = produtosRascunho.findIndex(item => item.produto?.codigo == produto.codigo);
        produtosRascunho[idx].produto = produto;
      })

      // Atualiza a lista de produtos selecionados da solicitacao
      updateSolicitacaoProdutos(
        sortedSolicitacaoProdutos([...produtosRascunho])
      );
      showLoader(false);
    })();
  };

  //-----------------------------------------------------------------------------------------------------------------------------
  const adicionarProdutosObrigatorios = () => {
    if (
      !(
        (solicitacao.layoutProdutosObrigatorios || {}).produtosObrigatorios ||
        []
      ).length
    )
      return;

    let produtosObrigatorios =
      solicitacao.layoutProdutosObrigatorios.produtosObrigatorios;

    let naoInseridos = produtosObrigatorios.filter(
      (p) =>
        solicitacaoProdutos.findIndex((sp) => sp.produtoId === p.produtoId) ===
        -1
    );
    if (naoInseridos.length === 0) return;

    // naoInseridos.forEach((produtoObrigatorio) => {
    //   adicionarProduto(produtoObrigatorio);
    // });

    adicionarListaProdutos(naoInseridos);
  };

  //-----------------------------------------------------------------------------------------------------------------------------
  const isObrigatorio = (produto) => {
    return (
      (
        (solicitacao.layoutProdutosObrigatorios || {}).produtosObrigatorios ||
        []
      ).findIndex((p) => produto.produtoId === p.produtoId) !== -1
    );
  };

  //-----------------------------------------------------------------------------------------------------------------------------
  const sortedSolicitacaoProdutos = (lista) => {
    lista = lista.sort((produto) => (isObrigatorio(produto) ? -1 : 1));
    return lista.sort((produto) => (produto.produto.inovacao ? -1 : 1));
  };

  //-----------------------------------------------------------------------------------------------------------------------------
  const adicionarProduto = (produto) => {
    if (!loja || !loja.lojaId) return;

    if (
      solicitacaoProdutos.findIndex(
        (sp) => sp.produtoId === produto.produtoId
      ) !== -1
    )
      return;

    if (maximoProdutos > 0 && solicitacaoProdutos.length >= maximoProdutos)
      return;

    (async () => {
      showLoader(true);
      const result = await GET_SOLICITACAO_PRODUTO({
        lojaId: loja.lojaId,
        produtoId: produto.produtoId,
      });

      if (!result?.value) return;

      //pra funcionar no mobile
      let solicitacaoProduto = { ...result.value };
      solicitacaoProduto.produto = result.value;
      solicitacaoProduto.inovacao = result.value.inovacao;
      //--

      updateSolicitacaoProdutos(
        sortedSolicitacaoProdutos([...solicitacaoProdutos, solicitacaoProduto])
      );

      showLoader(false);
    })();
  };

  //-----------------------------------------------------------------------------------------------------------------------------
  const adicionarListaProdutos = (produtos) => {
    showLoader(false);
    if (!loja || !loja.lojaId) return;

    let naoInseridos = produtos.filter(
      (p) =>
        solicitacaoProdutos.findIndex((sp) => sp.produtoId === p.produtoId) ===
        -1,
    );
    if (naoInseridos.length === 0) return;

    (async function () {
      showLoader(true);

      let tempList = [];
      for (let i = 0; i < naoInseridos.length; i++) {
        let produto = naoInseridos[i];
        const result = await GET_SOLICITACAO_PRODUTO({
          lojaId: loja.lojaId,
          produtoId: produto.produtoId,
        });

        if (!result?.value) {
          continue;
        }

        //pra funcionar no mobile
        let solicitacaoProduto = { ...result.value };
        solicitacaoProduto.produto = result.value;
        solicitacaoProduto.inovacao = result.inovacao;
        //--

        tempList.push(solicitacaoProduto);
      }
      updateSolicitacaoProdutos(
        sortedSolicitacaoProdutos([...solicitacaoProdutos, ...tempList])
      );
      showLoader(false);
    })();
  };

  //-----------------------------------------------------------------------------------------------------------------------------
  const removerProduto = (produto) => {
    let index = solicitacaoProdutos.findIndex(
      (sp) => sp.produtoId === produto.produtoId
    );
    if (index === -1) return;

    solicitacaoProdutos.splice(index, 1);
    updateSolicitacaoProdutos([...solicitacaoProdutos]);
  };

  //-----------------------------------------------------------------------------------------------------------------------------
  const updateSolicitacaoProdutos = (lista) => {
    solicitacao.solicitacaoProdutos = lista;

    setSolicitacaoProdutos(lista);
  };

  //-----------------------------------------------------------------------------------------------------------------------------
  const formatPreco = (preco) => {
    return 'R$ ' + preco.toFixed(2).replace('.', ',');
  };

  //-----------------------------------------------------------------------------------------------------------------------------
  const getClassErrorPrecoRange = (produto) => {
    if (!produto.preco) return '';

    if (!produto.precoMinimo && !produto.precoMaximo) return '';

    let preco = parseFloat(produto.preco.toString().replace(',', '.'));

    if (preco < produto.precoMinimo) return 'produto-error';

    if (preco > produto.precoMaximo) return 'produto-error';

    return '';
  };

  //=============================================================================================================================
  const renderFiltro = () => {
    if (!layoutArte.possuiProdutosEspecificos) {
      return (
        <BuscaProdutos
          material={material}
          entities={entities}
          solicitacao={solicitacao}
          solicitacaoProdutos={solicitacaoProdutos}
          adicionarProduto={adicionarProduto}
          requerProdutoInovacao={requerProdutoInovacao}
        />
      );
    }

    if (
      !layoutProdutosEspecificos ||
      !layoutProdutosEspecificos.produtosEspecificos ||
      !layoutProdutosEspecificos.produtosEspecificos.length
    ) {
      return (
        <BuscaProdutos
          entities={entities}
          solicitacao={solicitacao}
          solicitacaoProdutos={solicitacaoProdutos}
          adicionarProduto={adicionarProduto}
          requerProdutoInovacao={requerProdutoInovacao}
        />
      );
    }

    return (
      <ProdutosEspecificos
        entities={entities}
        solicitacao={solicitacao}
        solicitacaoProdutos={solicitacaoProdutos}
        adicionarProduto={adicionarProduto}
        layoutProdutosEspecificos={layoutProdutosEspecificos}
        requerProdutoInovacao={requerProdutoInovacao}
      />
    );
  };

  //-----------------------------------------------------------------------------------------------------------------------------
  const renderSolicitacaoProdutos = () => {
    if (!solicitacaoProdutos.length) return null;

    let countInovacoesSelecionados = countInovacao(solicitacaoProdutos);
    return (
      <div className="mt-4">

        {!requerProdutoInovacao && (<h5>{solicitacaoProdutos.length} produto(s) selecionado(s)</h5>)}
        {(requerProdutoInovacao && countInovacoesSelecionados === 0) && (<h5>{solicitacaoProdutos.length} produto(s) selecionado(s) sendo nenhuma inovação</h5>)}
        {(requerProdutoInovacao && countInovacoesSelecionados === 1) && (<h5>{solicitacaoProdutos.length} produto(s) selecionado(s) sendo uma inovação</h5>)}
        {(requerProdutoInovacao && countInovacoesSelecionados > 1) && (<h5>{solicitacaoProdutos.length} produto(s) selecionado(s) sendo {countInovacoesSelecionados} inovações</h5>)}

        {(requerProdutoInovacao && inovacaoMsgErro !== '') && (<h5 style={{ color: 'red' }}>{inovacaoMsgErro}</h5>)}

        {maximoProdutos > 0 && solicitacaoProdutos.length >= maximoProdutos && (
          <div className="alert alert-warning">
            O máximo de produtos {maximoProdutos} foi atingido, não é possível
            adicionar mais produtos.
          </div>
        )}

        <div className="grid-solicitacao-produtos">
          {solicitacaoProdutos.map((solicitacaoProduto, index) => {
            return (
              <div key={index} className="row grid-row-produto">
                <div className="col-lg-12 p-0 text-right">
                  {isObrigatorio(solicitacaoProduto) ? (
                    <i>produto obrigatório</i>
                  ) : (
                    <FaTimes
                      onClick={() => {
                        removerProduto(solicitacaoProduto);
                      }}
                    />
                  )}
                </div>
                <div className="col-lg-2 image-container">
                  <img
                    src={solicitacaoProduto.urlImagemMiniatura}
                    className="img-fluid"
                  />
                </div>
                <div className="col-lg-10">

                  <div className="row">
                    <div className="col-lg-2">
                      <label>Código</label>
                      {solicitacaoProduto.produto.codigo}
                    </div>
                    <div className="col-lg-6">
                      <div className="row mb-2">
                        <div className="col-lg-12">
                          <label>Produto</label>
                          {solicitacaoProduto.produto.nome}
                        </div>
                      </div>
                      <div className="row">
                        <div
                          className={`col-lg-12 ${getCampoObrigatorioClassName(
                            (
                              solicitacaoProduto.produto
                                ?.produtoDetalhamentos || []
                            ).length === 0 ||
                            (
                              solicitacaoProduto.solicitacaoProdutoDetalhamentos ||
                              []
                            ).length > 0,
                            true
                          )}`}
                        >
                          {(
                            solicitacaoProduto.produto?.produtoDetalhamentos ||
                            []
                          ).map((detalhamento, index) => {
                            return (
                              <label key={index} className="label-checkbox">
                                <input
                                  type="checkbox"
                                  checked={
                                    (
                                      solicitacaoProduto.solicitacaoProdutoDetalhamentos ||
                                      []
                                    ).findIndex(
                                      (x) =>
                                        x.produtoDetalhamentoId ===
                                        detalhamento.produtoDetalhamentoId
                                    ) !== -1
                                  }
                                  onChange={(event) => {
                                    solicitacaoProduto.solicitacaoProdutoDetalhamentos =
                                      solicitacaoProduto.solicitacaoProdutoDetalhamentos ||
                                      [];

                                    if (event.target.checked) {
                                      solicitacaoProduto.solicitacaoProdutoDetalhamentos.push(
                                        {
                                          produtoDetalhamentoId:
                                            detalhamento.produtoDetalhamentoId,
                                        }
                                      );
                                    } else {
                                      solicitacaoProduto.solicitacaoProdutoDetalhamentos =
                                        solicitacaoProduto.solicitacaoProdutoDetalhamentos.filter(
                                          (x) =>
                                            x.produtoDetalhamentoId !==
                                            detalhamento.produtoDetalhamentoId
                                        );
                                    }

                                    updateSolicitacaoProdutos([
                                      ...solicitacaoProdutos,
                                    ]);
                                  }}
                                />
                                {detalhamento.descricao}
                              </label>
                            );
                          })}
                        </div>
                      </div>
                    </div>

                    {/* Inovacao / Destaque ------------------------------------------------------- */}
                    {requerProdutoInovacao ?
                      (
                        <>
                          <div className="col-lg-2 text-right">
                            {solicitacaoProduto.produto.inovacao && (
                              <label style={{ color: 'green' }}>
                                <span><FaStar /></span> Inovação{' '}
                              </label>
                            )}
                          </div>
                          <div className="col-lg-2 text-right">
                            <label>
                              Destacar{' '}
                              <input
                                type="checkbox"
                                checked={solicitacaoProduto.destaque}
                                onChange={(event) => {
                                  solicitacaoProduto.destaque = event.target.checked;
                                  updateSolicitacaoProdutos([...solicitacaoProdutos]);
                                }}
                              />
                            </label>
                          </div>
                        </>
                      )
                      :
                      (
                        <>
                          <div className="col-lg-3 pr-4 text-right">
                            <label>
                              Destacar{' '}
                              <input
                                type="checkbox"
                                checked={solicitacaoProduto.destaque}
                                onChange={(event) => {
                                  solicitacaoProduto.destaque = event.target.checked;
                                  updateSolicitacaoProdutos([...solicitacaoProdutos]);
                                }}
                              />
                            </label>
                          </div>
                        </>
                      )
                    }

                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <label>Descrição no Encarte</label>
                      <input
                        type="text"
                        className={`form-control ${getCampoObrigatorioClassName(
                          solicitacaoProduto.descricao,
                          true
                        )}`}
                        value={solicitacaoProduto.descricao || ''}
                        onChange={(event) => {
                          solicitacaoProduto.descricao = event.target.value;
                          updateSolicitacaoProdutos([...solicitacaoProdutos]);
                        }}
                      />
                    </div>
                    <div className="col-lg-6">
                      <label>Observação</label>
                      <input
                        type="text"
                        className="form-control"
                        value={solicitacaoProduto.observacao || ''}
                        onChange={(event) => {
                          solicitacaoProduto.observacao = event.target.value;
                          updateSolicitacaoProdutos([...solicitacaoProdutos]);
                        }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-2">
                      <label>Oferta</label>
                      <Switch
                        checked={solicitacaoProduto.oferta || false}
                        onChange={(checked) => {
                          solicitacaoProduto.oferta = checked;
                          updateSolicitacaoProdutos([...solicitacaoProdutos]);
                        }}
                      />
                    </div>

                    <div className="col-lg-4">
                      <div className="row">
                        {!solicitacaoProduto.oferta ? (
                          <div className="col-lg-12">
                            <label>Preço</label>
                            <CurrencyInput
                              decimalSeparator=","
                              thousandSeparator=""
                              className={`form-control ${getCampoObrigatorioClassName(
                                solicitacaoProduto.preco,
                                true
                              )} ${getClassErrorPrecoRange(
                                solicitacaoProduto
                              )}`}
                              value={solicitacaoProduto.preco || ''}
                              onChangeEvent={(event) => {
                                solicitacaoProduto.preco = event.target.value;
                                updateSolicitacaoProdutos([
                                  ...solicitacaoProdutos,
                                ]);
                              }}
                            />
                          </div>
                        ) : (
                          <>
                            <div className="col-lg-6">
                              <label>De</label>
                              <CurrencyInput
                                decimalSeparator=","
                                thousandSeparator=""
                                className={`form-control ${getCampoObrigatorioClassName(
                                  solicitacaoProduto.precoDe,
                                  true
                                )}`}
                                value={solicitacaoProduto.precoDe || ''}
                                onChangeEvent={(event) => {
                                  solicitacaoProduto.precoDe =
                                    event.target.value;
                                  updateSolicitacaoProdutos([
                                    ...solicitacaoProdutos,
                                  ]);
                                }}
                              />
                            </div>

                            <div className="col-lg-6">
                              <label>Por</label>
                              <CurrencyInput
                                decimalSeparator=","
                                thousandSeparator=""
                                className={`form-control ${getCampoObrigatorioClassName(
                                  solicitacaoProduto.preco,
                                  true
                                )} ${getClassErrorPrecoRange(
                                  solicitacaoProduto
                                )}`}
                                value={solicitacaoProduto.preco || ''}
                                onChangeEvent={(event) => {
                                  solicitacaoProduto.preco = event.target.value;
                                  updateSolicitacaoProdutos([
                                    ...solicitacaoProdutos,
                                  ]);
                                }}
                              />
                            </div>
                          </>
                        )}
                      </div>

                      {!solicitacaoProduto.precoMinimo &&
                        !solicitacaoProduto.precoMaximo ? null : (
                        <div className="row">
                          <div className="col-lg-12">
                            min: {formatPreco(solicitacaoProduto.precoMinimo)}{' '}
                            &mdash; max:{' '}
                            {formatPreco(solicitacaoProduto.precoMaximo)}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="col-lg-6">
                      <label>Unidade</label>
                      <Select
                        options={selectListUnidades}
                        isClearable={true}
                        className={getCampoObrigatorioClassName(
                          solicitacaoProduto.unidade,
                          true
                        )}
                        onChange={(item) => {
                          solicitacaoProduto.unidade = item?.value;
                          updateSolicitacaoProdutos([...solicitacaoProdutos]);
                        }}
                        value={selectListUnidades.find(
                          (item) => item.value === solicitacaoProduto.unidade
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  //=============================================================================================================================
  return (
    <div>
      {renderErrors(errors)}

      <h4 className="text-danger text-center">
        Quantidade de Produtos Inseridos: {solicitacaoProdutos.length}
      </h4>
      {material.validaProdutoObrigatorioRegional &&
        <>
          <h5 className="text-danger text-center">
            Quantidade Mínima de Itens Obrigatórios: {entities.regionalProdutosObrigatorios.minimoProdutos}%
          </h5>
          <h5 className="text-danger text-center">
            Quantidade de Itens Obrigatórios adicionados: {itensObrigatoriosAdicionados==0? 0 :Math.floor((itensObrigatoriosAdicionados / solicitacaoProdutos.length) * 100)}%
          </h5>
        </>
      }
      <h5 className="text-danger text-center">
        Mínimo: {minimoProdutos}/Máximo: {maximoProdutos}
      </h5>
      <hr />

      {renderFiltro()}

      <hr />

      {renderSolicitacaoProdutos()}

      <div className="row mt-5">
        {!hideVoltar && (
          <div className="col btn-avancar-voltar ">
            <button
              className="btn btn-primary btn-navigation"
              onClick={() => voltar()}
            >
              <span>
                <FaAngleLeft size={26} />
              </span>
              <span>VOLTAR</span>
            </button>
          </div>
        )}

        <div className="col btn-avancar-voltar d-flex flex-row-reverse">
          <button
            className="btn btn-primary btn-navigation btn-navigation-right"
            onClick={() => avancar()}
          >
            <span>AVANÇAR</span>
            <span>
              <FaAngleRight size={26} />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Produtos;
